import marySImg from './mary_s.jpg';
import jordanPImg from './jordan_p.jpg';
import jamieTImg from './jamie_t.jpg';
import bradyOImg from './brady_o.jpg';
import westRImg from './west_r.jpg';
import dawnSImg from './dawn_s.jpg';
import logo3Step from './Logo_3Step.png';
import logoAAU from './Logo_AAU.png';
import logoAJGA from './Logo_American Junior Golf Association (AJGA).png';
import logoMichigan from './Logo_Michigan.png';
import logoPennState from './Logo_pennstate.png';
import logoPrepNetwork from './Logo_PrepNetwork.png';
import logoPrinceton from './Logo_Princeton University.png';
import logoTripleCrownSports from './Logo_TripleCrownSports.png';
import logoUSAFootball from './Logo_USA Football.png';
import logoUSClubSoccer from './Logo_USClubSoccer.png';

export const items = [
  {
    key: 1,
    name: 'Mary S.',
    location: 'Fairfield, CT',
    workedJobs: 368,
    image: marySImg,
  },
  {
    key: 2,
    name: 'Jordan P.',
    location: 'Dallas, TX',
    workedJobs: 113,
    image: jordanPImg,
  },
  {
    key: 3,
    name: 'Jamie T.',
    location: 'Orlando, FL',
    workedJobs: 237,
    image: jamieTImg,
  },
  {
    key: 4,
    name: 'Brady O.',
    location: 'San Jose, CA',
    workedJobs: 224,
    image: bradyOImg,
  },
  {
    key: 5,
    name: 'West R.',
    location: 'Montevideo, MN',
    workedJobs: 59,
    image: westRImg,
  },
  {
    key: 6,
    name: 'Dawn S.',
    location: 'Downingtown, PA',
    workedJobs: 176,
    image: dawnSImg,
  },
]

export const brandsLogo =
  [
    {
      imageUrl: logoUSClubSoccer,
      width: '100%',
      height: '120%',
    },
    {
      imageUrl: logoPennState,
      width: '60%',
      height: '80%',
      objectFit: 'cover',
    },
    {
      imageUrl: logo3Step,
      width: '100%',
      height: '100%',
    },
    {
      imageUrl: logoMichigan,
      width: '100%',
      height: '60%',
    },
    {
      imageUrl: logoPrepNetwork,
      width: '100%',
      height: '100%',
    },
    {
      imageUrl: logoTripleCrownSports,
      width: '100%',
      height: '100%',
    },
    {
      imageUrl: logoPrinceton,
      width: '100%',
      height: '100%',
    },
    {
      imageUrl: logoAAU,
      width: '100%',
      height: '90%',
    },
    {
      imageUrl: logoUSAFootball,
      width: '100%',
      height: '100%',
    },
    {
      imageUrl: logoAJGA,
      width: '100%',
      height: '90%',
    },
  ]